/**
 * id
 * label
 * inputName
 * options
 * errorMsg
 * className
 * width
 * disabled
 * _function
 */
import React, { useState } from 'react';
import './FormGroup.css'

const SelectGroup = props => {
    const [isFocused, setIsFocused] = useState(false);
    const {
        id,
        label,
        errorMsg,
        options,
        className,
        disabled,
        width,
        inputName,
        _function,
        isUpper
    } = props

    return (
        <div className={`_form-group ${className} ${errorMsg && '_form-group-invalid'} ${disabled && '_form-group-disabled'}`} style={{
            ...(width ? { width } : {})
        }}>
            <label htmlFor={id} className={isFocused ? 'active' : ''}>
                {label}
            </label>
            <select
                name={inputName}
                id={id}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => _function(e.target.value)}
                defaultValue={'--'}
                disabled={disabled}
            >
                <option disabled value={"--"}>--</option>
                {options?.map((d, i) => <option key={i} value={`${d.value}${d.label?.length ? ` - ${d.label}` : ''}`}>{isUpper ? d.value.toUpperCase() : d.value}</option>)}
            </select>


            {errorMsg && <span className='_form-group-error-msg '>{errorMsg}</span>}
        </div>
    );
};
export default SelectGroup;
